/**
 * Keeps the legacy buy-now option controls and the submitted variant ID in sync.
 * The section renders both radio and select controls; radios take precedence.
 */
document.addEventListener('change', (event) => {
  if (!(event.target instanceof HTMLInputElement || event.target instanceof HTMLSelectElement)) return;
  if (!event.target.matches('[data-product-option]')) return;

  const optionsContainer = event.target.closest('[data-product-options]');
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!optionsContainer || !form) return;

  const variantSelect = form.querySelector('select[data-variants][name="id"]');
  if (!(variantSelect instanceof HTMLSelectElement)) return;

  const optionNames = [
    ...new Set(
      [...optionsContainer.querySelectorAll('[data-product-option]')]
        .map((control) => control.getAttribute('data-product-option'))
        .filter(Boolean)
    ),
  ];

  const selectedValues = optionNames.map((optionName) => {
    const checkedRadio = optionsContainer.querySelector(
      `input[data-product-option="${CSS.escape(optionName)}"]:checked`
    );
    if (checkedRadio instanceof HTMLInputElement) return checkedRadio.value;

    const select = optionsContainer.querySelector(`select[data-product-option="${CSS.escape(optionName)}"]`);
    return select instanceof HTMLSelectElement ? select.value : '';
  });

  const variantOption = [...variantSelect.options].find((option) => {
    try {
      const values = JSON.parse(option.dataset.optionValues || '[]');
      return values.every((value, index) => value === selectedValues[index]);
    } catch (_) {
      return false;
    }
  });

  const submitButton = form.querySelector('button[type="submit"][name="add"]');
  const submitText = submitButton?.querySelector('[data-product-text]');

  if (!variantOption) {
    if (submitButton instanceof HTMLButtonElement) submitButton.disabled = true;
    if (submitText) submitText.textContent = 'UNAVAILABLE';
    return;
  }

  variantSelect.value = variantOption.value;
  variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

  const available = variantOption.dataset.available === 'true';
  if (submitButton instanceof HTMLButtonElement) submitButton.disabled = !available;
  if (submitText) submitText.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
});
